import {Component, OnInit, TemplateRef} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APIHelper} from "../../../apihelper";
import {SharedResources} from "../../../shared-resources";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomValidatorsService} from "../../../customvalidators.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-input-product',
  templateUrl: './input-product.component.html',
  styleUrls: ['./input-product.component.css']
})
export class InputProductComponent implements OnInit {

  countries : any = [];
  greenstamps : any = [];
  productsForm = new FormGroup(
    {
      Id: new FormControl(''),
      Vendor: new FormControl('',
        [
          Validators.required
        ]),
      PartNo: new FormControl('',
        [
          Validators.required
        ]),
      Eccn: new FormControl('',
        [
          Validators.pattern('(^[A-Z]{3}[0-9]{2}$)|(^[0-9][A-Z][0-9]{3}$)|(^[0-9][A-Z][0-9]{3}\\.[a-z]\\.[0-9]$)|(^[0-9][A-Z][0-9]{3}\\.[a-z]$)'),
          Validators.required
        ]),
      HsCode: new FormControl('',
        [
          Validators.pattern('^[0-9]{8}$'),
          Validators.required
      ]),
      TaraOrigine: new FormControl('',
        [
          Validators.required
        ]),
      CategorieTimbruVerde: new FormControl('',
        [
        Validators.required
      ])
    }
  )
  numberOfPartPages: number = 0;
  currentPartPage: number = 0;
  parts: any = [];
  currentPartName: string = '';

  constructor(private http: HttpClient, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.productsForm.controls.Id.setValue('00000000-0000-0000-0000-000000000000');
    this.http.get<any>(`${APIHelper.APIUrl}country`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.countries = response.map((t : any) => t.Nume + ' (' + t.Cod + ')').sort((t1: any, t2: any) => {
          return t1.localeCompare(t2);
        });
      }, (error: any) => {
      alert("Eroare la încărcarea țărilor!");
      SharedResources._isLoadingBS.next(false);
    });

    this.http.get<any>(`${APIHelper.APIUrl}greenstamp`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.greenstamps = response.map((gs : any) => gs.Nume).sort((gs1: any, gs2: any) => {
          return gs1.localeCompare(gs2);
        });
      }, (error: any) => {
        alert("Eroare la încărcarea timbrelor verzi!");
        SharedResources._isLoadingBS.next(false);
      });
  }

  cancelAddProduct() {
    SharedResources.currentScreen = 'products';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  addProduct(inputProductForm: any) {
    SharedResources._isLoadingBS.next(true);
    this.http.post<any>(`${APIHelper.APIUrl}product`,
      inputProductForm.value,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.http.post<any>(`${APIHelper.APIUrl}part`,
          {
            PartNo : inputProductForm.value.PartNo,
            PartNames : this.parts
          },
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('token')}`
            })
          }).subscribe(
          (response: any) => {
            SharedResources._isLoadingBS.next(false);
            SharedResources._currentScreenBS.next('products');
            alert("Produs adăugat cu succes!");
          },(error: any) => {
            SharedResources._isLoadingBS.next(false);
            SharedResources._currentScreenBS.next('products');
            alert("Eroare la salvarea pieselor!");
          });

      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  goToNextPage() {
    this.currentPartPage++;
    if (this.currentPartPage > this.numberOfPartPages)
      this.currentPartPage = 1;
  }

  goToPrevPage() {
    this.currentPartPage--;
    if (this.currentPartPage <= 0)
      this.currentPartPage = this.numberOfPartPages;
  }

  deletePart(part: string) {
    this.parts = this.parts.filter((p : any) => p.toUpperCase() != part.toUpperCase());
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);
    if (this.currentPartPage > this.numberOfPartPages)
      this.currentPartPage = 1;
  }

  applyPartsModifications(modalParts: any) {
    modalParts.dismiss();
  }

  modifyParts(modalParts: TemplateRef<any>) {
    this.currentPartName = '';
    this.currentPartPage = 1;
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);

    this.modalService.open(modalParts, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false
    }).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  getParts() {
    return this.parts.filter((value : any, index : any) => (index >= (this.currentPartPage - 1) * 5 && index < this.currentPartPage * 5));
  }

  addPart() {
    if (this.parts.map((p : any) => p.toUpperCase()).includes(this.currentPartName.toUpperCase())) {
      alert("Piesa a mai fost introdusă!");
      return;
    }
    if (this.currentPartName == '') {
      return;
    }
    this.parts.push(this.currentPartName);
    this.currentPartName = '';
    this.numberOfPartPages = this.parts.length % 5 == 0 ?
      Math.floor(this.parts.length / 5) : (Math.floor(this.parts.length / 5) + 1);
  }
}

